import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import { map } from 'lodash';
import Tooltip from '@material-ui/core/Tooltip';
import CircularLoader from '../../../shared/components/CircularLoader/CircularLoader';
import ProgressBar from '../../../shared/components/ProgressBar/ProgressBar';
import { useStorageUsage } from '../../hooks/useStorageUsage';
import styles from './storageUsage.module.scss';

export default memo(function StorageUsage(props) {
    const { t } = useTranslation(['common', 'dashboard']);

    useStorageUsage(props.getStorageUsageRequest);

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <div className={styles.titleContainer}>
                    <span>{t('dashboard:storage_usage')}</span>
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={t('dashboard:storage_usage_detail')}
                    >
                        <span>{t('dashboard:storage_usage_detail')}</span>
                    </Tooltip>
                </div>
                {props.storageUsage.fetching && <CircularLoader size={24} />}
                {
                    !props.storageUsage.fetching &&
                    props.storageUsage.error &&
                    props.storageUsage.usage &&
                    <Tooltip
                        className={styles.tooltip}
                        disableFocusListener
                        disableTouchListener
                        title={t('dashboard:update_error')}
                    >
                        <div>
                            <SVG cacheGetRequests className={styles.icon} src="./icons/error.svg" />
                        </div>
                    </Tooltip>
                }
            </div>
            {
                props.storageUsage.error &&
                !props.storageUsage.usage &&
                <div className={styles.cloudError}>
                    <SVG cacheGetRequests className={styles.icon} src="./icons/cloud_error.svg" />
                    <span>{t('common:no_information_available')}</span>
                </div>
            }
            {
                props.storageUsage.usage &&
                <div className={styles.informationContainer}>
                    {map(props.storageUsage.usage, (storageDetail, index) => (
                        <div className={styles.storageDataContainer} key={index}>
                            <div className={styles.detailContainer}>
                                <span className={styles.detailName}>{t(`common:${storageDetail.name}`)}</span>
                                &nbsp;
                            <span className={styles.detailValue}>- {storageDetail.size}</span>
                            </div>
                            <ProgressBar percentage={storageDetail.percentage} />
                        </div>
                    ))}
                </div>
            }
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.storageUsage === nextProps.storageUsage &&
        prevProps.getStorageUsageRequest === nextProps.getStorageUsageRequest
);
